/* ============================================================================
FILE: po-katupirsia5-katuvys-texts-fr-en-es-20260303.js
MODE: TwinLang FR/EN/ES via localStorage + lexicon override (termes FR) si présent
API:  window.PoKatupirsia5KatuvysTextsFR_EN_ES_20260303
ROOT: .po-axis-section[data-po-axis="katuvys"] / [data-po-lex-id="katuvys"]
ROLE:
  - Langue pilotée par localStorage : po_lex_lang + goody_gp_lang
  - Boutons FR/EN/ES gérés par l’asset
  - Bloc protégé des traductions extérieures
  - Protection fine des occurrences canoniques FR si le lexique simplifié est disponible
  - Ajoute une couche audio locale et générale sans casser la logique existante
============================================================================ */
(function(){
  "use strict";

  if (window.__PO_K5_KATUVYS_TEXTS_20260303__) return;
  window.__PO_K5_KATUVYS_TEXTS_20260303__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var AXIS_LEX_ID = "katuvys";
  var ROOT_SEL =
    '.po-axis-section[data-po-axis][data-po-lex-id="' + AXIS_LEX_ID + '"], ' +
    '.po-axis-section[data-po-axis="' + AXIS_LEX_ID + '"], ' +
    '.po-axis-section[data-po-lex-id="' + AXIS_LEX_ID + '"]';

  function clampStr(v){ return (v == null) ? "" : String(v); }

  function normLang(raw){
    var s = clampStr(raw).toLowerCase().trim().replace(/_/g, "-");
    if (s === "fr" || s.indexOf("fr") === 0) return "fr";
    if (s === "en" || s.indexOf("en") === 0) return "en";
    if (s === "es" || s.indexOf("es") === 0) return "es";
    return "fr";
  }

  function readStoredLang(){
    var v = "";
    try{ v = localStorage.getItem(STORAGE_KEY) || ""; }catch(e){ v = ""; }
    if (!v){
      try{ v = localStorage.getItem(STORAGE_KEY_COMPAT) || ""; }catch(_e){ v = ""; }
    }
    return v ? normLang(v) : "";
  }

  function storeLang(lang){
    var l = normLang(lang);
    try{ localStorage.setItem(STORAGE_KEY, l); }catch(e){}
    try{ localStorage.setItem(STORAGE_KEY_COMPAT, l); }catch(_e){}
    try{ if (document && document.documentElement) document.documentElement.setAttribute("lang", l); }catch(__e){}
    return l;
  }

  function getLang(){
    var s = readStoredLang();
    if (s) return s;
    var dl = "";
    try{ dl = (document && document.documentElement) ? (document.documentElement.getAttribute("lang") || "") : ""; }catch(e){ dl = ""; }
    if (dl) return normLang(dl);
    return "fr";
  }

  function notifyLocaleChanged(){
    try{
      window.dispatchEvent(new Event("po:locale-changed"));
    }catch(e){
      try{
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      }catch(_e){}
    }
  }

  function getLexiconEntry(id){
    try{
      if (window.PO_LEXICON_MAP && window.PO_LEXICON_MAP[id]) return window.PO_LEXICON_MAP[id];
    }catch(e){}
    try{
      var arr = window.PO_LEXICON;
      if (Array.isArray(arr)){
        for (var i=0;i<arr.length;i++){
          if (arr[i] && arr[i].id === id) return arr[i];
        }
      }
    }catch(e){}
    return null;
  }

  function pickTerm(entry, lang){
    if (!entry) return "";
    try{
      if (entry.terms && entry.terms[lang]) return clampStr(entry.terms[lang]);
    }catch(e){}
    return "";
  }

  function pickAny(entry, key, fallback){
    try{
      if (entry && entry[key] != null) return entry[key];
    }catch(e){}
    return fallback;
  }

  function escapeHTML(s){
    return clampStr(s)
      .replace(/&/g,"&amp;")
      .replace(/</g,"&lt;")
      .replace(/>/g,"&gt;")
      .replace(/"/g,"&quot;")
      .replace(/'/g,"&#39;");
  }

  function escapeRegExp(s){
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function uniqPush(arr, v, seen){
    var k = String(v || "");
    if (!k) return;
    if (seen[k]) return;
    seen[k] = true;
    arr.push(k);
  }

  function buildVariants(term){
    var out = [];
    var seen = Object.create(null);
    var t = clampStr(term);
    if (!t) return out;

    uniqPush(out, t, seen);
    uniqPush(out, t.replace(/’/g, "'"), seen);
    uniqPush(out, t.replace(/'/g, "’"), seen);
    uniqPush(out, t.replace(/œ/g, "oe").replace(/Œ/g, "OE"), seen);
    uniqPush(out, t.replace(/oe/g, "œ").replace(/OE/g, "Œ"), seen);

    var oe1 = t.replace(/œ/g, "oe").replace(/Œ/g, "OE");
    var oe2 = t.replace(/oe/g, "œ").replace(/OE/g, "Œ");
    uniqPush(out, oe1.replace(/’/g, "'"), seen);
    uniqPush(out, oe1.replace(/'/g, "’"), seen);
    uniqPush(out, oe2.replace(/’/g, "'"), seen);
    uniqPush(out, oe2.replace(/'/g, "’"), seen);

    return out;
  }

  function getSimplifiedLexiqueFRList(){
    try{
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)){
        return window.PO_LEXICON_META.lexique_simplifie_fr.slice();
      }
    }catch(e){}
    try{
      if (window.PO_LEXICON && window.PO_LEXICON.meta && Array.isArray(window.PO_LEXICON.meta.lexique_simplifie_fr)){
        return window.PO_LEXICON.meta.lexique_simplifie_fr.slice();
      }
    }catch(e){}
    try{
      if (window.PO_LEXIQUE_SIMPLIFIE && window.PO_LEXIQUE_SIMPLIFIE.meta && Array.isArray(window.PO_LEXIQUE_SIMPLIFIE.meta.lexique_simplifie_fr)){
        return window.PO_LEXIQUE_SIMPLIFIE.meta.lexique_simplifie_fr.slice();
      }
    }catch(e){}
    try{
      if (Array.isArray(window.PO_LEXIQUE_SIMPLIFIE_FR)) return window.PO_LEXIQUE_SIMPLIFIE_FR.slice();
    }catch(e){}
    return [];
  }

  function buildProtectRegexFromSimplified(){
    var base = getSimplifiedLexiqueFRList();
    if (!base || !base.length) return null;

    var terms = [];
    var seen = Object.create(null);

    for (var i=0;i<base.length;i++){
      var vars = buildVariants(base[i]);
      for (var j=0;j<vars.length;j++) uniqPush(terms, vars[j], seen);
    }

    terms.sort(function(a,b){ return b.length - a.length; });
    var parts = [];
    for (var k=0;k<terms.length;k++) parts.push(escapeRegExp(terms[k]));
    if (!parts.length) return null;

    try{ return new RegExp("(" + parts.join("|") + ")", "g"); }
    catch(e){ return null; }
  }

  var __PO_PROTECT_CACHE__ = { key:"", re:null };

  function ensureProtectEngineReady(){
    var key = "meta:none";
    try{
      var l = getSimplifiedLexiqueFRList();
      key = "meta:" + (l ? l.length : 0);
    }catch(e){ key = "meta:none"; }
    if (__PO_PROTECT_CACHE__.key === key) return;
    __PO_PROTECT_CACHE__.key = key;
    __PO_PROTECT_CACHE__.re = buildProtectRegexFromSimplified();
  }

  function isLockedElement(el){
    if (!el || el.nodeType !== 1) return false;
    var tr = el.getAttribute && el.getAttribute("translate");
    if (tr && String(tr).toLowerCase() === "no") return true;
    var cls = el.className || "";
    if (typeof cls === "string"){
      if (cls.indexOf("notranslate") !== -1) return true;
      if (cls.indexOf("po-lex-protect") !== -1) return true;
    }
    return false;
  }

  function isLockedNode(node){
    var el = (node && node.nodeType === 1) ? node : (node ? node.parentElement : null);
    while (el && el.nodeType === 1){
      if (isLockedElement(el)) return true;
      el = el.parentElement;
    }
    return false;
  }

  function isWordLikeChar(ch){
    return /[0-9A-Za-zÀ-ÖØ-öø-ÿ_]/.test(ch);
  }

  function protectTextNode(doc, textNode){
    ensureProtectEngineReady();
    var re = __PO_PROTECT_CACHE__.re;
    if (!re) return;
    var txt = textNode.nodeValue;
    if (!txt) return;
    re.lastIndex = 0;
    if (!re.test(txt)) return;

    re.lastIndex = 0;
    var frag = doc.createDocumentFragment();
    var last = 0, m;

    while ((m = re.exec(txt)) !== null){
      var start = m.index;
      var match = m[0];
      var end = start + match.length;

      if (start > last) frag.appendChild(doc.createTextNode(txt.slice(last, start)));

      var chPrev = (start - 1 >= 0) ? txt.charAt(start - 1) : "";
      if (chPrev && isWordLikeChar(chPrev)) frag.appendChild(doc.createTextNode(" "));

      var span = doc.createElement("span");
      span.setAttribute("translate", "no");
      span.className = "po-lex-protect notranslate";
      span.textContent = match;
      frag.appendChild(span);

      var chNext = (end < txt.length) ? txt.charAt(end) : "";
      if (chNext && isWordLikeChar(chNext)) frag.appendChild(doc.createTextNode(" "));

      last = end;
      if (match.length === 0) break;
    }

    if (last < txt.length) frag.appendChild(doc.createTextNode(txt.slice(last)));
    if (textNode.parentNode) textNode.parentNode.replaceChild(frag, textNode);
  }

  function protectKeywordsHTML(html){
    if (!html) return "";
    ensureProtectEngineReady();

    var tpl = document.createElement("template");
    tpl.innerHTML = String(html);
    var root = tpl.content || tpl;
    var walker;

    try{
      walker = document.createTreeWalker(
        root,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode: function(n){
            if (!n || !n.nodeValue) return NodeFilter.FILTER_REJECT;
            if (isLockedNode(n)) return NodeFilter.FILTER_REJECT;
            return NodeFilter.FILTER_ACCEPT;
          }
        },
        false
      );
    }catch(e){ return String(html); }

    var nodes = [];
    var t;
    while ((t = walker.nextNode())) nodes.push(t);
    for (var i=0;i<nodes.length;i++) protectTextNode(document, nodes[i]);
    return tpl.innerHTML;
  }

  function htmlParagraphize(txt){
    var s = clampStr(txt);
    if (!s) return "";
    return "<p>" + escapeHTML(s).replace(/\n+/g, "</p><p>") + "</p>";
  }

  function canon(txt){
    return '<span class="notranslate" translate="no">' + escapeHTML(clampStr(txt)) + '</span>';
  }

  function getTargetBlocks(){
    return Array.prototype.slice.call(document.querySelectorAll(ROOT_SEL) || []);
  }

  /* --------------------------------------------------------------------------
   * AUDIO LOCAL PAR BLOC + TEXTE GÉNÉRAL
   * -------------------------------------------------------------------------- */

  var PO_AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis) ? window.speechSynthesis : null;
  var PO_AUDIO_STATE = { root:null, units:[], unitPos:-1, chunks:[], chunkPos:-1, activeKey:"", lang:"fr", voice:null };
  var AUDIO_UI = {
    fr: { general: "Écouter le texte", block: "Écouter ce bloc", stop: "Arrêter la lecture" },
    en: { general: "Listen to the text", block: "Listen to this section", stop: "Stop playback" },
    es: { general: "Escuchar el texto", block: "Escuchar este bloque", stop: "Detener la lectura" }
  };

  function audioUI(lang){ var L = normLang(lang); return AUDIO_UI[L] || AUDIO_UI.fr; }
  function getAudioRoots(){ return getTargetBlocks(); }
  function getDetailBlocks(root){ return root ? Array.prototype.slice.call(root.querySelectorAll(".po-lex-details") || []) : []; }

  function ensureAudioStyles(){
    if (!document || document.getElementById("po-k5-katuvys-audio-style")) return;
    var style = document.createElement("style");
    style.id = "po-k5-katuvys-audio-style";
    style.textContent =
      ".po-axis-audio-wrap{margin:12px 0 14px;display:flex;justify-content:flex-start;}" +
      ".po-axis-audio-btn{appearance:none;border:1px solid rgba(0,0,0,.14);background:rgba(0,0,0,.03);color:inherit;border-radius:999px;padding:8px 12px;font:inherit;font-size:12px;font-weight:800;line-height:1.2;cursor:pointer;display:inline-flex;align-items:center;gap:8px;max-width:100%;}" +
      ".po-axis-audio-btn:hover{background:rgba(0,0,0,.05);}" +
      ".po-axis-audio-btn.is-playing{background:rgba(0,0,0,.08);}" +
      ".po-axis-audio-btn__icon{display:inline-block;min-width:1em;text-align:center;}" +
      ".po-axis-section[data-po-axis] .po-lex-summary .po-axis-audio-btn{margin-left:auto;flex:0 0 auto;}" +
      ".po-axis-section[data-po-axis] .po-axis-audio-btn__label{white-space:normal;}" +
      "@media (max-width:760px){.po-axis-section[data-po-axis] .po-lex-summary{align-items:flex-start;}.po-axis-section[data-po-axis] .po-lex-summary .po-axis-audio-btn{margin-left:0;}}";
    document.head.appendChild(style);
  }

  function createAudioButton(role){
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "po-axis-audio-btn";
    btn.setAttribute("data-po-audio-role", role);

    var icon = document.createElement("span");
    icon.className = "po-axis-audio-btn__icon";
    icon.setAttribute("aria-hidden", "true");
    icon.textContent = "⏵";

    var label = document.createElement("span");
    label.className = "po-axis-audio-btn__label";

    btn.appendChild(icon);
    btn.appendChild(label);
    return btn;
  }

  function ensureAudioButtons(root){
    if (!root) return;
    ensureAudioStyles();

    var panel = root.querySelector(".po-lex-panel");
    if (panel){
      var generalWrap = root.querySelector(".po-axis-audio-wrap[data-po-audio-role='general']");
      if (!generalWrap){
        generalWrap = document.createElement("div");
        generalWrap.className = "po-axis-audio-wrap";
        generalWrap.setAttribute("data-po-audio-role", "general");

        var generalBtn = createAudioButton("general");
        generalWrap.appendChild(generalBtn);

        var defShort = root.querySelector("[data-po-slot='def_short']");
        var firstDetail = panel.querySelector(".po-lex-details");

        if (defShort && defShort.parentNode){
          defShort.parentNode.insertBefore(generalWrap, defShort);
        } else if (firstDetail && firstDetail.parentNode){
          firstDetail.parentNode.insertBefore(generalWrap, firstDetail);
        } else {
          panel.appendChild(generalWrap);
        }
      }
    }

    var details = getDetailBlocks(root);
    for (var i=0;i<details.length;i++){
      var detail = details[i];
      var summary = detail.querySelector(".po-lex-summary");
      if (!summary) continue;

      var btn = summary.querySelector(".po-axis-audio-btn[data-po-audio-role='detail']");
      if (!btn){
        btn = createAudioButton("detail");
        summary.appendChild(btn);
      }
      btn.setAttribute("data-po-audio-index", String(i));
    }
  }

  function setButtonVisualState(btn, lang, isPlaying){
    if (!btn) return;
    var ui = audioUI(lang);
    var role = btn.getAttribute("data-po-audio-role") || "detail";
    var label = btn.querySelector(".po-axis-audio-btn__label");
    var icon = btn.querySelector(".po-axis-audio-btn__icon");

    if (btn.classList && btn.classList.toggle) btn.classList.toggle("is-playing", !!isPlaying);
    if (icon) icon.textContent = isPlaying ? "⏸" : "⏵";
    if (label) label.textContent = isPlaying ? ui.stop : ((role === "general") ? ui.general : ui.block);
  }

  function refreshAudioLabels(root, lang){
    if (!root) return;
    var btns = root.querySelectorAll(".po-axis-audio-btn");
    var activeKey = (PO_AUDIO_STATE.root === root) ? PO_AUDIO_STATE.activeKey : "";
    for (var i=0;i<btns.length;i++){
      var btn = btns[i];
      var role = btn.getAttribute("data-po-audio-role") || "detail";
      var key = (role === "general") ? "general" : ("detail:" + clampStr(btn.getAttribute("data-po-audio-index")));
      setButtonVisualState(btn, lang, !!activeKey && key === activeKey);
    }
  }

  function getTextValue(el){
    if (!el) return "";
    var txt = "";
    try{ txt = el.textContent || el.innerText || ""; }catch(e){ txt = ""; }
    return clampStr(txt).replace(/\s+/g, " ").trim();
  }

  function removeAudioButtonsFromClone(root){
    if (!root || !root.querySelectorAll) return;
    var btns = root.querySelectorAll(".po-axis-audio-wrap, .po-axis-audio-btn");
    for (var i=0;i<btns.length;i++) if (btns[i] && btns[i].parentNode) btns[i].parentNode.removeChild(btns[i]);
  }

  function collectGeneralText(root){
    var parts = [];
    var slots = ["title", "kicker", "h_def", "def_short", "def_long"];
    for (var i=0;i<slots.length;i++){
      var el = root.querySelector("[data-po-slot='" + slots[i] + "']");
      var txt = getTextValue(el);
      if (txt) parts.push(txt);
    }
    return parts.join(". ");
  }

  function collectDetailText(detail){
    if (!detail) return "";
    var parts = [];
    var title = detail.querySelector(".po-lex-summary__title");
    var titleText = getTextValue(title);
    if (titleText) parts.push(titleText);

    var clone = detail.cloneNode(true);
    var summary = clone.querySelector(".po-lex-summary");
    if (summary && summary.parentNode) summary.parentNode.removeChild(summary);
    removeAudioButtonsFromClone(clone);

    var bodyText = getTextValue(clone);
    if (bodyText) parts.push(bodyText);
    return parts.join(". ");
  }

  function splitTextForSpeech(text){
    var raw = clampStr(text).replace(/\s+/g, " ").trim();
    if (!raw) return [];
    var pieces = raw.match(/[^.!?;:]+[.!?;:]?/g) || [raw];
    var out = [];
    var current = "";
    for (var i=0;i<pieces.length;i++){
      var piece = clampStr(pieces[i]).trim();
      if (!piece) continue;
      var candidate = current ? (current + " " + piece) : piece;
      if (candidate.length > 220){
        if (current) out.push(current.trim());
        current = piece;
      }else{
        current = candidate;
      }
    }
    if (current) out.push(current.trim());
    return out;
  }

  function pickVoiceForLang(lang){
    if (!PO_AUDIO_SYNTH || typeof PO_AUDIO_SYNTH.getVoices !== "function") return null;
    var voices = PO_AUDIO_SYNTH.getVoices() || [];
    if (!voices.length) return null;
    var L = normLang(lang);
    var prefs = L === "fr" ? ["fr", "fr-fr", "fr_ca", "fr-ca"] : (L === "es" ? ["es", "es-es", "es_mx", "es-mx"] : ["en", "en-us", "en-gb"]);
    var i, j, code, v, tag;
    for (j=0;j<prefs.length;j++){
      code = prefs[j];
      for (i=0;i<voices.length;i++){
        v = voices[i];
        tag = clampStr(v.lang).toLowerCase().replace(/_/g, "-");
        if (tag === code || tag.indexOf(code + "-") === 0) return v;
      }
    }
    for (i=0;i<voices.length;i++){
      v = voices[i];
      tag = clampStr(v.lang).toLowerCase();
      if (tag.indexOf(L) === 0) return v;
    }
    return voices[0] || null;
  }

  function buildUnits(root, role, index){
    var units = [];
    var details = getDetailBlocks(root);
    if (role === "general"){
      units.push({ role:"general", index:-1 });
      for (var i=0;i<details.length;i++) units.push({ role:"detail", index:i });
      return units;
    }
    var start = (typeof index === "number" && index >= 0) ? index : 0;
    for (var j=start;j<details.length;j++) units.push({ role:"detail", index:j });
    return units;
  }

  function stopAudio(){
    try{
      if (PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending)) PO_AUDIO_SYNTH.cancel();
    }catch(e){}

    var roots = getAudioRoots();
    for (var i=0;i<roots.length;i++) refreshAudioLabels(roots[i], getLang());

    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = "";
    PO_AUDIO_STATE.lang = getLang();
    PO_AUDIO_STATE.voice = null;
  }

  function playCurrentUnit(reuseChunks){
    if (!PO_AUDIO_SYNTH || !PO_AUDIO_STATE.root) return;

    if (PO_AUDIO_STATE.unitPos < 0 || PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length){
      stopAudio();
      return;
    }

    var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
    var text = "";

    if (unit.role === "general"){
      PO_AUDIO_STATE.activeKey = "general";
      text = collectGeneralText(PO_AUDIO_STATE.root);
    }else{
      PO_AUDIO_STATE.activeKey = "detail:" + unit.index;
      var details = getDetailBlocks(PO_AUDIO_STATE.root);
      var detail = details[unit.index];
      if (detail){
        detail.open = true;
        text = collectDetailText(detail);
      }
    }

    refreshAudioLabels(PO_AUDIO_STATE.root, PO_AUDIO_STATE.lang || getLang());

    if (!reuseChunks){
      PO_AUDIO_STATE.chunks = splitTextForSpeech(text);
      PO_AUDIO_STATE.chunkPos = 0;
    }

    if (!PO_AUDIO_STATE.chunks.length){
      PO_AUDIO_STATE.unitPos += 1;
      playCurrentUnit(false);
      return;
    }

    speakCurrentChunk();
  }

  function speakCurrentChunk(){
    if (!PO_AUDIO_SYNTH || !PO_AUDIO_STATE.root) return;
    if (PO_AUDIO_STATE.chunkPos < 0 || PO_AUDIO_STATE.chunkPos >= PO_AUDIO_STATE.chunks.length){
      PO_AUDIO_STATE.unitPos += 1;
      playCurrentUnit(false);
      return;
    }

    var utter = new SpeechSynthesisUtterance(PO_AUDIO_STATE.chunks[PO_AUDIO_STATE.chunkPos]);
    var lang = PO_AUDIO_STATE.lang || getLang();
    utter.lang = lang === "fr" ? "fr-FR" : (lang === "es" ? "es-ES" : "en-US");
    utter.rate = 0.95;
    utter.pitch = 1;
    utter.voice = PO_AUDIO_STATE.voice || pickVoiceForLang(lang);

    utter.onend = function(){
      PO_AUDIO_STATE.chunkPos += 1;
      if (PO_AUDIO_STATE.chunkPos < PO_AUDIO_STATE.chunks.length) speakCurrentChunk();
      else {
        PO_AUDIO_STATE.unitPos += 1;
        playCurrentUnit(false);
      }
    };
    utter.onerror = function(){
      PO_AUDIO_STATE.chunkPos += 1;
      if (PO_AUDIO_STATE.chunkPos < PO_AUDIO_STATE.chunks.length) speakCurrentChunk();
      else {
        PO_AUDIO_STATE.unitPos += 1;
        playCurrentUnit(false);
      }
    };

    try{ PO_AUDIO_SYNTH.speak(utter); }
    catch(e){
      PO_AUDIO_STATE.chunkPos += 1;
      if (PO_AUDIO_STATE.chunkPos < PO_AUDIO_STATE.chunks.length) speakCurrentChunk();
      else {
        PO_AUDIO_STATE.unitPos += 1;
        playCurrentUnit(false);
      }
    }
  }

  function startAudio(root, role, index){
    if (!PO_AUDIO_SYNTH || !root) return;
    stopAudio();
    var lang = getLang();
    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = buildUnits(root, role, index);
    PO_AUDIO_STATE.unitPos = 0;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = "";
    PO_AUDIO_STATE.lang = lang;
    PO_AUDIO_STATE.voice = pickVoiceForLang(lang);
    playCurrentUnit(false);
  }

  function bindAudioButtons(root){
    if (!root) return;
    var btns = root.querySelectorAll(".po-axis-audio-btn");
    for (var i=0;i<btns.length;i++){
      var btn = btns[i];
      if (btn.__poAudioBound) continue;
      btn.addEventListener("click", function(ev){
        ev.preventDefault();
        ev.stopPropagation();
        var role = this.getAttribute("data-po-audio-role") || "detail";
        var index = parseInt(this.getAttribute("data-po-audio-index"), 10);
        var key = (role === "general") ? "general" : ("detail:" + (isNaN(index) ? -1 : index));
        var sameRoot = (PO_AUDIO_STATE.root === root);
        var sameKey = (PO_AUDIO_STATE.activeKey === key);
        if (sameRoot && sameKey && (PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending))){ stopAudio(); return; }
        startAudio(root, role, isNaN(index) ? -1 : index);
      });
      btn.__poAudioBound = true;
    }
  }

  function initAudioEverywhere(lang){
    var roots = getAudioRoots();
    for (var i=0;i<roots.length;i++){
      ensureAudioButtons(roots[i]);
      bindAudioButtons(roots[i]);
      refreshAudioLabels(roots[i], lang || getLang());
    }
  }

  try{
    if (PO_AUDIO_SYNTH && typeof PO_AUDIO_SYNTH.addEventListener === "function"){
      PO_AUDIO_SYNTH.addEventListener("voiceschanged", function(){
        if (PO_AUDIO_STATE.root) PO_AUDIO_STATE.voice = pickVoiceForLang(PO_AUDIO_STATE.lang || getLang());
      });
    }
  }catch(e){}

  var URLS = {
    title_img: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Katuvys_copie.png?v=1750254535",
    katusys_img: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Katusys_copie.png?v=1772885244",
    balakallpa_img: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Balakallpa_copie.png?v=1772893364",
    isqun_img: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/L_Isqun_copie.png?v=1772883682",
    threnisqun_img: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/threnisqun_2_copie.png?v=1772883862",
    ekho_img: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Ekho.png?v=1773404195",
    posoennomnese_img: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Posoennomnese_copie.png?v=1773412807",
    humanus_img: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Humanus_conceptuel.png?v=1774459599",

    katuvys: "https://goodyart.store/pages/katuvys",
    katusys: "https://goodyart.store/pages/katusys",
    balakallpa: "https://goodyart.store/pages/balakallpa",
    isqun: "https://goodyart.store/pages/isqun",
    threnisqun: "https://goodyart.store/pages/threnisqun",
    ekho: "https://goodyart.store/pages/ekho",
    posoennomnese: "https://goodyart.store/pages/posoennomnese",
    humanus: "https://goodyart.store/pages/humanus"
  };

  var FALLBACK = {
    fr: {
      title: "Katûvýs",
      kicker:
        "Extrait du <em>Katûpirsia&nbsp;5 - La Matrice-substrat</em><br />(Matrice-substrat vibratoire du Posœnnoïsme)",

      h_def: "Définition opérative",

      def_short:
        "Matrice-substrat vibratoire du Posœnnoïsme, continuum matriciel où circulent temps, espace, mémoire, perception et symbolique. Elle accueille Organon, Système, Posœnnoïa et Posœnnomia, soutient les intensités, et inscrit dans sa trame des dynamiques telles que la Pistis Chraomai. Elle constitue le grand champ de Katûsýs et le milieu de surgissement de Balakallpa.",

      def_long:
        "La Katûvýs peut être définie comme une matrice-substrat vibratoire, non située, non localisable, agissant hors des coordonnées classiques de matière, de temps et d’espace. Elle se déploie comme continuum matriciel, topologie vivante et champ spiralé opératif où les formes, les seuils, les transmissions et les cycles trouvent leur tenue. Elle n’est pas un décor cosmique ni un simple fond d’apparition, mais le lieu-source où l’opérativité prend corps, où les passages se rendent possibles et où les reconfigurations gardent leur charge transmissible.\n\n" +
        "Elle accueille, module et redistribue les intensités traversant les plans sensoriel, symbolique, énergétique, cognitif et poïétique. En elle, la mémoire ne se fige jamais en dépôt mort : elle demeure souffle, réserve active, tension de reprise et de relance. La Katûvýs porte ainsi une fonction morphogénétique et transductive ; elle rend possible l’émergence des formes, leur traversée, leur modulation, leur requalification et leur transmission au sein du système posœnnoïal.\n\n" +
        "Le corpus la présente aussi comme le grand champ dont Katûsýs constitue l’anatomie interne — corps spiralé, noyau opératif, tissu premier — tandis que Balakallpa désigne les formes émanées surgissant des interactions entre ces organes internes et les composantes actives du système. La Katûvýs n’est donc ni un organe isolé ni une simple somme d’éléments, mais la matrice au sein de laquelle Organon, Système, Posœnnoïa, Posœnnomia, organes, régulations, émanations et pratiques se répondent.\n\n" +
        "Ainsi, la Katûvýs apparaît comme une trame vibratoire multidimensionnelle où plusieurs bandes de fréquences potentielles interagissent : Katûsýs pour les structures d’émergence, Balakallpa pour l’opérativité transmutative, Threnisqun pour la régulation des intensités, et Isqun pour l’activation des Sceaux dont la convergence donne naissance à l’Ennéagone régulateur. Ensemble, ces champs composent une architecture vivante de propagation où les dynamiques du sens, de la perception et du devenir circulent au sein du système posœnnoïal.\n\n" +
        "En tant que matrice première, la Katûvýs précède toute structuration numérique. Elle n’est pas « privée » de nombre-guide ; elle se tient en amont du nombre comme foyer générateur d’où procèdent les fréquences attribuées aux éléments dérivés, aux modalités, aux accords, aux Katûvýsqun et aux unités qui s’en dégagent. Elle demeure ainsi hors-cadre numérique : non quantifiable en elle-même, mais génératrice de quantifications dérivées.\n\n" +
        "Dans cette perspective, la Katûvýs peut se lire comme espace-source, mémoire active, respiration morphogénétique, champ de modulation et de portance des formes, topologie vibratoire où s’élaborent les conditions d’émergence, de passage, de réagencement et de transmission.",

      h_bands: "Bandes et ensembles opératifs",
      h_annexes: "Annexes",
      h_totem: "Totem",

      h_features: "Schématisation",
      h_questions: "Repères d’activation",
      hint_fold: "déplier",
      hint_fold2: "déplier",
      hint_fold3: "déplier",

      example_title: "Ex.",
      example:
        "Quand tu décris la source où l’opérativité prend corps, où une expérience change de régime sans perdre sa continuité, tu parles de Katûvýs. Quand tu nommes les organes internes — mémoire, nœud, interface, convergence, canalisation, modulation, ossature du sens — tu bascules vers Katûsýs. Quand tu nommes une forme apparue à partir de leurs interactions avec modalités, accords ou synchrêssions, tu parles de Balakallpa.",

      features: [
        "Statut : matrice-substrat vibratoire ; continuum matriciel et champ spiralé opératif où baignent Organon, Système, Posœnnoïa, Posœnnomia, organes internes, émanations et pratiques.",
        "Régime d’existence : non située, non localisable ; topologie vivante d’interconnexion entre formes, tensions, fréquences, mémoires et seuils.",
        "Fonction fondamentale : donner la tenue du passage ; maintenir la continuité quand une œuvre, une pensée, un rituel ou une expérience change de régime.",
        "Opérations majeures : accueillir, moduler, redistribuer, rendre disponible ; faire circuler les intensités entre plans sensoriel, symbolique, énergétique, cognitif et poïétique.",
        "Portance mémorielle : archive active sans fossilisation ; ce qui est traversé peut y demeurer transmissible, réactivable et reconfigurable.",
        "Rapport à l’Organon : la Katûvýs représente le champ matriciel global ; l’Organon en constitue la structure opérative, l’atelier de mise en œuvre du champ.",
        "Articulation interne : Katûsýs relève de l’intériorité structurelle de la matrice ; Balakallpa relève du régime d’émanation et de manifestation.",
        "Écologie interne : la Katûvýs déploie des unités vibratoires actives, organes de mémoire, de seuil, de modulation, de perception, de propagation et de passage.",
        "Rapport aux nombres-guides : foyer générateur antérieur à la structuration numérique ; elle rend possible l’attribution des fréquences sans être réductible à une fréquence propre.",
        "Portée cosmique : tissu de passage, respiration morphogénétique, matrice de création et d’évolution, où lumière, mémoire et modulation se croisent en une même tenue."
      ],

      questions: [
        "Suis-je en train de décrire le grand champ de continuité où l’opérativité prend corps, ou un organe interne plus précis ?",
        "Ce que j’observe relève-t-il d’une intériorité structurelle de la matrice (Katûsýs), d’une émanation fonctionnelle (Balakallpa), ou du champ-source lui-même (Katûvýs) ?",
        "Quel plan se trouve modulé ici : sensoriel, symbolique, énergétique, cognitif, poïétique — et quel seuil rend cette modulation sensible ?",
        "Ai-je affaire à une mémoire active qui conserve sans figer, à une redistribution d’intensités, à une relance, ou à une simple description de surface ?",
        "Suis-je en train d’exiger un repère numérique, alors que le phénomène demande d’être lu depuis le foyer générateur antérieur au nombre-guide ?",
        "Le passage décrit garde-t-il sa charge transmissible à travers la transformation, la rupture apparente, le changement de forme ou de rythme ?",
        "La présence de Pistis Chraomai agit-elle ici comme confiance opérative inscrite dans la trame, soutenant une bascule, une orientation ou une ouverture ?"
      ],

      h_family: "Position & distinction (Katûsýs / Balakallpa)",
      family_1:
        "<p><strong>Katûsýs :</strong> ensemble des éléments constitutifs internes de la <strong>Katûvýs</strong>. Il en forme le corps spiralé, le noyau opératif, le tissu premier, l’anatomie vibratoire. Nommer <strong>Katûsýs</strong>, c’est quitter la vue du grand champ pour entrer dans la précision des organes, des régulations, des passages et des foyers internes.</p>",
      family_2:
        "<p><strong>Balakallpa :</strong> ensemble des formes émanées résultant des interactions entre les éléments de <strong>Katûsýs</strong>, la <strong>Katûvýs</strong> et les composantes actives du système (modalités, accords, synchrêssions, intentions matricielles). Il ne s’agit pas d’un organe interne, mais d’un régime d’émergence, de manifestation et de prolongement fonctionnel du champ.</p>",

      h_wordbuild: "Construction du mot (K5) : Katû + výs",
      word_blocks: [
        {
          head: "1) Katû = Ka + Tû (porte vibratoire)",
          text:
            "Ka : souffle, vie, activation, matrice sonore, énergie d’appel. Tû : profondeur, descente, gravité, silence actif, axe d’immersion. Katû forme ainsi un moteur de traversée : immersion transmutative, plongée consciente dans un champ vibratoire vivant, traversée active des intensités rendues disponibles à l’expérience, à la pensée et à l’opération poïétique."
        },
        {
          head: "2) výs : unité vibratoire et force d’ordonnancement",
          text:
            "Le corpus relie « výs » à plusieurs champs attestés : latin vis (force), sanskrit vij / vijñāna (discernement, énergie, conscience différenciée), vieux-slave / proto-slave (souffle, esprit, énonciation), slovaque / tchèque (hauteur, élévation), védique / indo-iranien (répandre, diffuser). L’ensemble compose une charge de force active, de souffle structurant, d’élévation et de diffusion."
        },
        {
          head: "3) Décomposition phonétique : v – ý – s",
          text:
            "v- : voie, vibration, vitalité, élan du vivant. -ý- : élongation, axe sonore, tension ascendante, élévation. -s : souffle, spiralité, structure, expansion terminale, trace organisatrice. Dans la logique posœnnoïale, « výs » devient vibration structurée du souffle, onde d’ordonnancement traversant les plans."
        },
        {
          head: "4) Composition du néologisme Katûvýs",
          text:
            "La composition n’additionne pas deux segments comme des pièces juxtaposées ; elle les tresse en une seule logique opérative. « Katû » apporte l’immersion transmutative dans un champ actif. « výs » apporte la tenue du souffle structuré, la propagation ordonnante et la dynamique d’élévation. « Katûvýs » nomme ainsi une immersion dans un champ qui ne se contente pas de recevoir : il module, redistribue, porte et ordonne les intensités en une matrice de passage."
        },
        {
          head: "Lecture opérative",
          text:
            "Katûvýs se lit comme immersion active et propagation structurée du souffle : une matrice-substrat où mémoire, forme, seuil, circulation, lumière et transmutation se répondent sans localisation fixe. Elle accueille les traversées, en garde la tenue, rend possible la reconfiguration des formes et maintient la transmissibilité du passage."
        }
      ],

      word_notes: [
        "La diacritique de « výs » porte dans le corpus une valeur tenue de marque vibratoire ; elle n’est pas décorative.",
        "Katûvýs précède les nombres-guides : elle demeure foyer générateur hors-cadre numérique.",
        "Nommer Katûvýs, c’est désigner le grand champ ; nommer Katûsýs, c’est préciser ses organes ; nommer Balakallpa, c’est désigner les formes émanées.",
        "La relation à la Pistis Chraomai peut être comprise comme inscription d’une confiance opérative dans la trame même de la matrice."
      ],

      h_usage: "Tests d’usage",
      usage_points: [
        "Si tu décris la source où l’opérativité prend corps, tu es en Katûvýs.",
        "Si tu parles de seuils, tensions, circulation, tenue du passage, cela se joue dans Katûvýs.",
        "Si tu listes les unités internes, les nœuds, interfaces, mémoires et régulations, tu es dans Katûsýs.",
        "Si une forme surgit d’une interaction entre matrice, organes et forces actives, tu lis un effet de Balakallpa.",
        "Si le phénomène demande un nombre-guide, tu as déjà quitté le niveau matriciel pur pour un niveau dérivé du champ."
      ],

      h_relations: "Relations systémiques",
      relations_html:
        "<p><strong>Avec l’Organon posœnnoïal :</strong> la <strong>Katûvýs</strong> est le champ matriciel global ; l’Organon en manifeste la conscience opérative, l’atelier où la pensée se forme avant de se dire.</p>" +
        "<p><strong>Avec la Posœnnoïa :</strong> la <strong>Posœnnoïa</strong> agit comme verbe-matrice, souffle de passage entre champ et forme, tension d’articulation traversant la <strong>Katûvýs</strong> et l’Organon.</p>" +
        "<p><strong>Avec Katûsýs / Balakallpa / Isqun / Threnisqun :</strong> la <strong>Katûvýs</strong> porte à la fois le corps matriciel interne, le continuum émanatoire, la structure régulatrice de fréquences et la bande de redistribution rituélique des excès. Ces bandes n’isolent pas le champ ; elles en rendent lisibles les régimes d’action.</p>" +
        "<p><strong>Avec la Pistis Chraomai :</strong> la confiance opérative s’inscrit dans la trame de la <strong>Katûvýs</strong>, y trouve une mémoire active et y soutient ouvertures, bascules, réajustements et transmissions.</p>" +
        "<p><strong>Avec Katûvýsissence :</strong> substance vibratoire primordiale et mémoire énergétique des mutations et des structurations, elle recueille dans le champ les traces actives des modulations, des seuils et des traversées.</p>",

      h_composition: "Composition du néologisme",
      composition_intro:
        "Le mot <strong>Katûvýs</strong> procède d’un tressage morphologique, vibratoire et symbolique. Il associe une logique d’immersion active à une logique de souffle structuré et de propagation ordonnante. Cette composition désigne moins un objet qu’un régime de champ.",
      composition_blocks: [
        {
          head: "Segment 1 — Katû",
          text:
            "Mouvement d’immersion transmutative, descente consciente dans un champ vibratoire vivant, traversée des intensités et disponibilité du réel à la modulation."
        },
        {
          head: "Segment 2 — výs",
          text:
            "Unité vibratoire de force, de souffle, d’élévation et d’ordonnancement ; onde de modulation traversant les plans, tenue structurante du champ."
        },
        {
          head: "Effet de la composition",
          text:
            "La réunion de ces segments produit l’idée d’une matrice-substrat : champ d’immersion, de propagation, de mémoire et de redistribution, où l’expérience garde sa continuité à travers ses changements de régime."
        }
      ],
      composition_notes: [
        "La composition est un tressage opératif, non une simple addition étymologique.",
        "Le mot désigne un régime de champ avant de désigner un élément conceptualisé.",
        "Le souffle y devient structure, et la structure y demeure vivante, modulante, transmissible."
      ],
      cta_translate: "Proposer une traduction du concept"
    },

    en: {},
    es: {}
  };

  FALLBACK.en = {
    title: "Katûvýs",
    kicker:
      "Excerpt from <em>Katûpirsia&nbsp;5 - La Matrice-substrat</em><br />(Vibratory matrix-substratum of the Posœnnoïsme)",
    h_def: "Operative definition",
    def_short:
      "Vibratory matrix-substratum of the Posœnnoïsme, a matricial continuum where time, space, memory, perception and symbolic layers circulate. It receives Organon, Système, Posœnnoïa and Posœnnomia, sustains intensities, and inscribes dynamics such as Pistis Chraomai within its weave. It is the great field of Katûsýs and the emergence-medium of Balakallpa.",
    def_long:
      "Katûvýs may be defined as a vibratory matrix-substratum: non-situated, non-localizable, acting beyond the classic coordinates of matter, time and space. It unfolds as a matricial continuum, a living topology and a spiral operative field in which forms, thresholds, transmissions and cycles gain consistency. It is neither a cosmic décor nor a mere background of appearance, but the source-field where operativity takes body, where passages become possible, and where reconfigurations preserve their transmissible charge.\n\n" +
      "It receives, modulates and redistributes intensities crossing sensory, symbolic, energetic, cognitive and poietic planes. In it, memory never hardens into inert deposit: it remains breath, active reserve, tension of reprise and relaunch. Katûvýs thus carries a morphogenetic and transductive function; it makes possible the emergence of forms, their traversal, modulation, requalification and transmission within the posœnnoïal system.\n\n" +
      "The corpus also presents it as the great field whose internal anatomy is Katûsýs — spiral body, operative core and first tissue — while Balakallpa designates the emanated forms arising from interactions between those internal organs and the active components of the system. Katûvýs is therefore neither an isolated organ nor a mere sum of elements, but the matrix within which Organon, Système, Posœnnoïa, Posœnnomia, organs, regulations, emanations and practices answer one another.\n\n" +
      "Katûvýs appears as a multidimensional vibratory weave in which several bands of potential frequencies interact: Katûsýs for emergence-structures, Balakallpa for transmutative operativity, Threnisqun for intensity-regulation, and Isqun for the activation of the Seals whose convergence generates the Ennéagone régulateur. Together these fields compose a living architecture of propagation where dynamics of meaning, perception and becoming circulate through the posœnnoïal system.\n\n" +
      "As first matrix, Katûvýs precedes any numerical structuring. It is not merely \"without\" a guide-number; it stands upstream of number as the generative focus from which frequencies attributed to derived elements, modalities, accords, Katûvýsqun and released units proceed. It therefore remains outside numeric framing: non-quantifiable in itself, yet generative of derivative quantifications.\n\n" +
      "In this perspective, Katûvýs can be read as source-space, active memory, morphogenetic respiration, field of modulation and bearing of forms, a vibratory topology where conditions of emergence, passage, rearrangement and transmission are elaborated.",
    h_bands: "Operative bands and ensembles",
    h_annexes: "Annexes",
    h_totem: "Totem",
    h_features: "Schematic view",
    h_questions: "Activation markers",
    hint_fold: "expand",
    hint_fold2: "expand",
    hint_fold3: "expand",
    example_title: "Ex.",
    example:
      "When you describe the source where operativity takes body, where an experience changes regime without losing continuity, you are speaking of Katûvýs. When you name the internal organs—memory, node, interface, convergence, canalization, modulation, scaffolding of meaning—you move to Katûsýs. When you name a form that appears from their interaction with modalities, accords or synchrêssions, you are speaking of Balakallpa.",
    features: FALLBACK.fr.features,
    questions: [
      "Am I describing the great continuity-field where operativity takes body, or a more precise internal organ?",
      "Does what I observe belong to the structural interiority of the matrix (Katûsýs), to a functional emanation (Balakallpa), or to the source-field itself (Katûvýs)?",
      "Which plane is being modulated here—sensory, symbolic, energetic, cognitive, poietic—and what threshold makes that modulation perceptible?",
      "Am I dealing with active memory that preserves without freezing, with redistribution of intensities, with relaunch, or only with surface description?",
      "Am I demanding a numeric marker while the phenomenon should be read from the generative focus prior to the guide-number?",
      "Does the described passage preserve its transmissible charge through transformation, apparent rupture, or change of form and rhythm?",
      "Is Pistis Chraomai acting here as operative trust woven into the matrix, sustaining an opening, an orientation or a shift?"
    ],
    h_family: "Position & distinction (Katûsýs / Balakallpa)",
    family_1:
      "<p><strong>Katûsýs :</strong> the set of internal constitutive elements of <strong>Katûvýs</strong>. It forms its spiral body, operative core, first tissue and vibratory anatomy. To name <strong>Katûsýs</strong> is to leave the view of the great field and enter the precision of organs, regulations, passages and internal focuses.</p>",
    family_2:
      "<p><strong>Balakallpa :</strong> the set of emanated forms resulting from interactions between the elements of <strong>Katûsýs</strong>, <strong>Katûvýs</strong> and the active components of the system (modalities, accords, synchrêssions, matricial intentions). It is not an internal organ, but a regime of emergence, manifestation and functional prolongation of the field.</p>",
    h_wordbuild: "Word-building (K5): Katû + výs",
    word_blocks: FALLBACK.fr.word_blocks,
    word_notes: [
      "The diacritic in “výs” carries an internal corpus-value as vibratory marking; it is not decorative.",
      "Katûvýs precedes guide-numbers: it remains a generative focus outside numeric framing.",
      "To name Katûvýs is to designate the great field; to name Katûsýs is to specify its organs; to name Balakallpa is to designate emanated forms.",
      "Its relation to Pistis Chraomai may be understood as the inscription of operative trust within the very weave of the matrix."
    ],
    h_usage: "Usage tests",
    usage_points: [
      "If you describe the source where operativity takes body, you are in Katûvýs.",
      "If you speak of thresholds, tensions, circulation, consistency of passage, this takes place in Katûvýs.",
      "If you list internal units, nodes, interfaces, memories and regulations, you are in Katûsýs.",
      "If a form emerges from an interaction between matrix, organs and active forces, you are reading an effect of Balakallpa.",
      "If the phenomenon requires a guide-number, you have already moved from the pure matricial level to a derivative level of the field."
    ],
    h_relations: "Systemic relations",
    relations_html:
      "<p><strong>With the Organon posœnnoïal :</strong> <strong>Katûvýs</strong> is the global matricial field; the Organon manifests its operative consciousness, the workshop where thought forms before it is spoken.</p>" +
      "<p><strong>With Posœnnoïa :</strong> <strong>Posœnnoïa</strong> acts as matrix-verb, breath of passage between field and form, tension of articulation crossing <strong>Katûvýs</strong> and the Organon.</p>" +
      "<p><strong>With Katûsýs / Balakallpa / Isqun / Threnisqun :</strong> <strong>Katûvýs</strong> carries both the internal matricial body, the emanatory continuum, the regulatory frequency-structure and the ritual redistribution band of excess. These bands do not isolate the field; they render its operative regimes legible.</p>" +
      "<p><strong>With Pistis Chraomai :</strong> operative trust is inscribed in the weave of <strong>Katûvýs</strong>, finding there an active memory that supports openings, shifts, readjustments and transmissions.</p>" +
      "<p><strong>With Katûvýsissence :</strong> primordial vibratory substance and energetic memory of mutations and structurings, it gathers within the field the active traces of modulations, thresholds and traversals.</p>",
    h_composition: "Composition of the neologism",
    composition_intro:
      "The word <strong>Katûvýs</strong> proceeds from a morphological, vibratory and symbolic braiding. It joins a logic of active immersion with a logic of structured breath and ordering propagation. This composition names less an object than a field-regime.",
    composition_blocks: [
      { head: "Segment 1 — Katû", text: "Movement of transmutative immersion, conscious descent into a living vibratory field, crossing of intensities and availability of the real to modulation." },
      { head: "Segment 2 — výs", text: "Vibratory unit of force, breath, elevation and ordering; wave of modulation crossing the planes, structuring consistency of the field." },
      { head: "Effect of the composition", text: "The union of these segments produces the idea of a matrix-substratum: field of immersion, propagation, memory and redistribution, where experience keeps its continuity through its regime-shifts." }
    ],
    composition_notes: [
      "The composition is an operative braiding, not a simple etymological addition.",
      "The word designates a field-regime before designating a conceptualized element.",
      "Breath becomes structure there, and structure remains alive, modulatory and transmissible."
    ],
    cta_translate: "Suggest a translation of the concept"
  };

  FALLBACK.es = {
    title: "Katûvýs",
    kicker:
      "Extracto de <em>Katûpirsia&nbsp;5 - La Matrice-substrat</em><br />(Matriz-sustrato vibratoria del Posœnnoïsme)",
    h_def: "Definición operativa",
    def_short:
      "Matriz-sustrato vibratoria del Posœnnoïsme, continuo matricial donde circulan tiempo, espacio, memoria, percepción y simbólico. Acoge Organon, Système, Posœnnoïa y Posœnnomia, sostiene intensidades e inscribe en su trama dinámicas como la Pistis Chraomai. Constituye el gran campo de Katûsýs y el medio de surgimiento de Balakallpa.",
    def_long:
      "Katûvýs puede definirse como una matriz-sustrato vibratoria: no situada, no localizable, actuando fuera de las coordenadas clásicas de materia, tiempo y espacio. Se despliega como continuo matricial, topología viva y campo operativo espiral donde formas, umbrales, transmisiones y ciclos adquieren consistencia. No es un decorado cósmico ni un simple fondo de aparición, sino el campo-fuente donde la operatividad toma cuerpo, donde los pasajes se vuelven posibles y donde las reconfiguraciones conservan su carga transmisible.\n\n" +
      "Acoge, modula y redistribuye intensidades que atraviesan planos sensoriales, simbólicos, energéticos, cognitivos y poiéticos. En ella, la memoria nunca se endurece como depósito inerte: permanece aliento, reserva activa, tensión de reanudación y relanzamiento. Katûvýs porta así una función morfogenética y transductiva; vuelve posible la emergencia de las formas, su travesía, modulación, recalificación y transmisión en el sistema posœnnoïal.\n\n" +
      "El corpus la presenta también como el gran campo cuya anatomía interna es Katûsýs — cuerpo espiral, núcleo operativo, tejido primero — mientras que Balakallpa designa las formas emanadas que surgen de las interacciones entre esos órganos internos y los componentes activos del sistema. Katûvýs no es, por tanto, ni un órgano aislado ni una simple suma de elementos, sino la matriz dentro de la cual Organon, Système, Posœnnoïa, Posœnnomia, órganos, regulaciones, emanaciones y prácticas se responden.\n\n" +
      "La Katûvýs aparece así como una trama vibratoria multidimensional donde interactúan varias bandas de frecuencias potenciales: Katûsýs para las estructuras de emergencia, Balakallpa para la operatividad transmutativa, Threnisqun para la regulación de intensidades e Isqun para la activación de los Sceaux cuya convergencia engendra el Ennéagone régulateur. Juntos, estos campos componen una arquitectura viva de propagación donde las dinámicas del sentido, de la percepción y del devenir circulan en el sistema posœnnoïal.\n\n" +
      "Como matriz primera, Katûvýs precede toda estructuración numérica. No está simplemente “sin” número-guía; se sitúa antes del número como foco generador del que proceden las frecuencias atribuidas a elementos derivados, modalidades, acuerdos, Katûvýsqun y otras unidades desplegadas. Permanece así fuera del marco numérico: no cuantificable en sí, aunque generadora de cuantificaciones derivadas.\n\n" +
      "Desde esta perspectiva, Katûvýs puede leerse como espacio-fuente, memoria activa, respiración morfogenética, campo de modulación y portancia de las formas, una topología vibratoria donde se elaboran las condiciones de emergencia, pasaje, reorganización y transmisión.",
    h_bands: "Bandas y conjuntos operativos",
    h_annexes: "Anexos",
    h_totem: "Tótem",
    h_features: "Esquematización",
    h_questions: "Referentes de activación",
    hint_fold: "desplegar",
    hint_fold2: "desplegar",
    hint_fold3: "desplegar",
    example_title: "Ej.",
    example:
      "Cuando describes la fuente donde la operatividad toma cuerpo, donde una experiencia cambia de régimen sin perder continuidad, hablas de Katûvýs. Cuando nombras los órganos internos—memoria, nudo, interfaz, convergencia, canalización, modulación, andamiaje del sentido—pasas a Katûsýs. Cuando nombras una forma surgida de su interacción con modalidades, acuerdos o synchrêssions, hablas de Balakallpa.",
    features: FALLBACK.fr.features,
    questions: [
      "¿Describo el gran campo de continuidad donde la operatividad toma cuerpo, o un órgano interno más preciso?",
      "¿Lo observado pertenece a la interioridad estructural de la matriz (Katûsýs), a una emanación funcional (Balakallpa), o al propio campo-fuente (Katûvýs)?",
      "¿Qué plano se modula aquí—sensorial, simbólico, energético, cognitivo, poiético—y qué umbral vuelve perceptible esa modulación?",
      "¿Estoy ante una memoria activa que conserva sin fijar, ante una redistribución de intensidades, un relanzamiento, o solo ante una descripción de superficie?",
      "¿Exijo un marcador numérico cuando el fenómeno pide ser leído desde el foco generador anterior al número-guía?",
      "¿El pasaje descrito conserva su carga transmisible a través de la transformación, la ruptura aparente o el cambio de forma y ritmo?",
      "¿Actúa aquí la Pistis Chraomai como confianza operativa inscrita en la trama de la matriz, sosteniendo una apertura, una orientación o un desplazamiento?"
    ],
    h_family: "Posición y distinción (Katûsýs / Balakallpa)",
    family_1:
      "<p><strong>Katûsýs :</strong> conjunto de los elementos constitutivos internos de <strong>Katûvýs</strong>. Forma su cuerpo espiral, núcleo operativo, tejido primero y anatomía vibratoria. Nombrar <strong>Katûsýs</strong> es salir de la visión del gran campo para entrar en la precisión de órganos, regulaciones, pasajes y focos internos.</p>",
    family_2:
      "<p><strong>Balakallpa :</strong> conjunto de formas emanadas que resultan de las interacciones entre los elementos de <strong>Katûsýs</strong>, la <strong>Katûvýs</strong> y los componentes activos del sistema (modalidades, acuerdos, synchrêssions, intenciones matriciales). No es un órgano interno, sino un régimen de emergencia, manifestación y prolongación funcional del campo.</p>",
    h_wordbuild: "Construcción (K5): Katû + výs",
    word_blocks: FALLBACK.fr.word_blocks,
    word_notes: [
      "La diacrítica de « výs » lleva en el corpus un valor de marca vibratoria; no es ornamental.",
      "Katûvýs precede los números-guía: permanece como foco generador fuera del marco numérico.",
      "Nombrar Katûvýs es designar el gran campo; nombrar Katûsýs es precisar sus órganos; nombrar Balakallpa es designar las formas emanadas.",
      "Su relación con la Pistis Chraomai puede comprenderse como inscripción de una confianza operativa en la propia trama de la matriz."
    ],
    h_usage: "Pruebas de uso",
    usage_points: [
      "Si describes la fuente donde la operatividad toma cuerpo, estás en Katûvýs.",
      "Si hablas de umbrales, tensiones, circulación, consistencia del pasaje, eso se juega en Katûvýs.",
      "Si enumeras unidades internas, nudos, interfaces, memorias y regulaciones, estás en Katûsýs.",
      "Si una forma surge de una interacción entre matriz, órganos y fuerzas activas, lees un efecto de Balakallpa.",
      "Si el fenómeno requiere un número-guía, ya has salido del nivel matricial puro hacia un nivel derivado del campo."
    ],
    h_relations: "Relaciones sistémicas",
    relations_html:
      "<p><strong>Con el Organon posœnnoïal :</strong> la <strong>Katûvýs</strong> es el campo matricial global; el Organon manifiesta su conciencia operativa, el taller donde el pensamiento se forma antes de decirse.</p>" +
      "<p><strong>Con la Posœnnoïa :</strong> la <strong>Posœnnoïa</strong> actúa como verbo-matriz, aliento de pasaje entre campo y forma, tensión de articulación que atraviesa <strong>Katûvýs</strong> y el Organon.</p>" +
      "<p><strong>Con Katûsýs / Balakallpa / Isqun / Threnisqun :</strong> la <strong>Katûvýs</strong> porta a la vez el cuerpo matricial interno, el continuo emanatorio, la estructura reguladora de frecuencias y la banda de redistribución ritual de los excesos. Estas bandas no aíslan el campo: vuelven legibles sus regímenes de acción.</p>" +
      "<p><strong>Con la Pistis Chraomai :</strong> la confianza operativa se inscribe en la trama de la <strong>Katûvýs</strong>, encuentra allí una memoria activa y sostiene aperturas, desplazamientos, reajustes y transmisiones.</p>" +
      "<p><strong>Con Katûvýsissence :</strong> sustancia vibratoria primordial y memoria energética de las mutaciones y las estructuraciones, recoge dentro del campo las huellas activas de modulaciones, umbrales y travesías.</p>",
    h_composition: "Composición del neologismo",
    composition_intro:
      "La palabra <strong>Katûvýs</strong> procede de un trenzado morfológico, vibratorio y simbólico. Reúne una lógica de inmersión activa con una lógica de aliento estructurado y propagación ordenante. Esta composición nombra menos un objeto que un régimen de campo.",
    composition_blocks: [
      { head: "Segmento 1 — Katû", text: "Movimiento de inmersión transmutativa, descenso consciente en un campo vibratorio vivo, cruce de intensidades y disponibilidad de lo real para la modulación." },
      { head: "Segmento 2 — výs", text: "Unidad vibratoria de fuerza, aliento, elevación y ordenación; onda de modulación que atraviesa los planos, consistencia estructurante del campo." },
      { head: "Efecto de la composición", text: "La unión de estos segmentos produce la idea de una matriz-sustrato: campo de inmersión, propagación, memoria y redistribución, donde la experiencia conserva su continuidad a través de sus cambios de régimen." }
    ],
    composition_notes: [
      "La composición es un trenzado operativo, no una simple suma etimológica.",
      "La palabra designa un régimen de campo antes de designar un elemento conceptualizado.",
      "El aliento se vuelve estructura y la estructura permanece viva, modulante y transmisible."
    ],
    cta_translate: "Proponer une traduction du concept"
  };

  function setSlotText(root, slot, txt){
    var el = root.querySelector("[data-po-slot='"+slot+"']");
    if (!el) return;
    el.textContent = clampStr(txt);
  }

  function setSlotHTML(root, slot, html){
    var el = root.querySelector("[data-po-slot='"+slot+"']");
    if (!el) return;
    el.innerHTML = protectKeywordsHTML(clampStr(html));
  }

  function setSlotImg(root, slot, src, alt){
    var el = root.querySelector("[data-po-slot='"+slot+"']");
    if (!el) return;
    var s = clampStr(src), a = clampStr(alt);
    if (!s){
      try{ el.removeAttribute("src"); }catch(e){}
      try{ el.setAttribute("alt", ""); }catch(e){}
      try{ el.style.display = "none"; }catch(e){}
      return;
    }
    try{ el.setAttribute("src", s); }catch(e){}
    try{ el.setAttribute("alt", a); }catch(e){}
    try{ el.style.display = ""; }catch(e){}
  }

  function renderListInto(root, slot, items){
    var el = root.querySelector("[data-po-slot='"+slot+"']");
    if (!el) return;
    var arr = Array.isArray(items) ? items : [];
    var out = [];
    for (var i=0;i<arr.length;i++) out.push("<li>" + protectKeywordsHTML(escapeHTML(clampStr(arr[i]))) + "</li>");
    el.innerHTML = out.join("");
  }

  function renderWordBlocks(root, slot, blocks){
    var host = root.querySelector("[data-po-slot='"+slot+"']");
    if (!host) return;
    var arr = Array.isArray(blocks) ? blocks : [];
    var out = [];
    for (var i=0;i<arr.length;i++){
      var b = arr[i] || {};
      out.push(
        '<div class="po-axis-wb">' +
          '<div class="po-axis-wb__h">' + protectKeywordsHTML(escapeHTML(clampStr(b.head || ""))) + '</div>' +
          '<div class="po-axis-wb__t">' + protectKeywordsHTML(escapeHTML(clampStr(b.text || ""))).replace(/\n/g,"<br />") + '</div>' +
        '</div>'
      );
    }
    host.innerHTML = out.join("");
  }

  function buildCard(item, lang){
    var button = { fr:"Voir la page", en:"Open page", es:"Ver la página" }[lang] || "Voir la page";
    var label = item.label && item.label[lang] ? item.label[lang] : "";
    var desc = item.desc && item.desc[lang] ? item.desc[lang] : "";
    return (
      '<article class="po-katu-card">' +
        '<a class="po-katu-card__title" href="' + item.href + '">' + canon(item.title) + '</a>' +
        '<div class="po-katu-card__mediawrap">' +
          '<div class="po-katu-card__media"><img class="po-katu-card__img" src="' + item.img + '" alt="" loading="lazy" decoding="async" /></div>' +
        '</div>' +
        (label ? '<div class="po-katu-card__label">' + escapeHTML(label) + '</div>' : '') +
        '<p class="po-katu-card__desc">' + desc + '</p>' +
        '<div class="po-katu-card__linkline"><a href="' + item.href + '">' + escapeHTML(button) + '</a></div>' +
      '</article>'
    );
  }

  function renderCardGrid(root, slot, items, lang){
    var el = root.querySelector("[data-po-slot='"+slot+"']");
    if (!el) return;
    var arr = Array.isArray(items) ? items : [];
    var out = [];
    for (var i=0;i<arr.length;i++) out.push(buildCard(arr[i], lang));
    el.innerHTML = out.join("");
  }

  function setCtaTranslate(root, lang){
    var el = root.querySelector('[data-po-slot="cta_translate"]');
    if (el) el.textContent = clampStr((FALLBACK[lang] && FALLBACK[lang].cta_translate) || FALLBACK.fr.cta_translate);
    var link = root.querySelector('.po-axis-breath-link');
    if (link){
      var map = {
        fr: "Proposer une traduction — Lexique simplifié",
        en: "Suggest a translation — Simplified lexicon",
        es: "Proponer una traducción — Léxico simplificado"
      };
      link.setAttribute("aria-label", map[lang] || map.fr);
    }
  }

  function resolveMainEntry(root){
    var id = "";
    try{ id = root.getAttribute("data-po-lex-id") || ""; }catch(e){ id = ""; }
    return (
      getLexiconEntry(id) ||
      getLexiconEntry("katuvys") ||
      getLexiconEntry("katûvýs") ||
      getLexiconEntry("katuvys_matrice_substrat") ||
      null
    );
  }

  function chooseFallback(lang){
    var l = normLang(lang);
    return FALLBACK[l] || FALLBACK.fr;
  }

  var BANDS = [
    {
      title:"Katûsýs",
      href: URLS.katusys,
      img: URLS.katusys_img,
      label: { fr:"Bande interne", en:"Internal band", es:"Banda interna" },
      desc: {
        fr: canon("Katûsýs") + " désigne l’ensemble spiralé des éléments constitutifs internes de " + canon("Katûvýs") + " : corps spiralé, noyau opératif, tissu premier du champ matriciel.",
        en: canon("Katûsýs") + " names the spiral ensemble of the internal constitutive elements of " + canon("Katûvýs") + ": spiral body, operative core and first tissue of the matricial field.",
        es: canon("Katûsýs") + " nombra el conjunto espiral de los elementos constitutivos internos de " + canon("Katûvýs") + ": cuerpo espiral, núcleo operativo y tejido primero del campo matricial."
      }
    },
    {
      title:"Balakallpa",
      href: URLS.balakallpa,
      img: URLS.balakallpa_img,
      label: { fr:"Bande émanatoire", en:"Emanatory band", es:"Banda emanatoria" },
      desc: {
        fr: canon("Balakallpa") + " qualifie le continuum des formes émanées issues des interactions entre " + canon("Katûvýs") + ", " + canon("Katûsýs") + " et les forces actives du système.",
        en: canon("Balakallpa") + " names the continuum of emanated forms arising from interactions between " + canon("Katûvýs") + ", " + canon("Katûsýs") + " and the active forces of the system.",
        es: canon("Balakallpa") + " nombra el continuo de formas emanadas surgidas de las interacciones entre " + canon("Katûvýs") + ", " + canon("Katûsýs") + " y las fuerzas activas del sistema."
      }
    },
    {
      title:"Isqun",
      href: URLS.isqun,
      img: URLS.isqun_img,
      label: { fr:"Structure régulatrice", en:"Regulatory structure", es:"Estructura reguladora" },
      desc: {
        fr: canon("Isqun") + " traverse " + canon("Katûvýs") + " comme structure régulatrice de fréquences ; ses neuf Sceaux et l’Ennéagone redistribuent les excès et maintiennent la cohérence des intensités.",
        en: canon("Isqun") + " crosses " + canon("Katûvýs") + " as a regulatory structure of frequencies; its nine Seals and the Ennéagone redistribute excess and maintain intensity-coherence.",
        es: canon("Isqun") + " atraviesa " + canon("Katûvýs") + " como estructura reguladora de frecuencias; sus nueve Sceaux y el Ennéagone redistribuyen los excesos y mantienen la coherencia de las intensidades."
      }
    },
    {
      title:"Threnisqun",
      href: URLS.threnisqun,
      img: URLS.threnisqun_img,
      label: { fr:"Bande de redistribution", en:"Redistribution band", es:"Banda de redistribución" },
      desc: {
        fr: canon("Threnisqun") + " constitue la bande vibratoire de régulation rituélique où les émanations isquniennes se condensent en neuf entités actives équilibrant les excès du champ.",
        en: canon("Threnisqun") + " constitutes the vibratory band of ritual regulation where isqunian emanations condense into nine active entities balancing the field’s excesses.",
        es: canon("Threnisqun") + " constituye la banda vibratoria de regulación ritual donde las emanaciones isqunianas se condensan en nueve entidades activas que equilibran los excesos del campo."
      }
    }
  ];

  var ANNEXES = [
    {
      title:"Posœnnomnèse",
      href: URLS.posoennomnese,
      img: URLS.posoennomnese_img,
      label: { fr:"Annexe opérative", en:"Operative annex", es:"Anexo operativo" },
      desc: {
        fr: canon("Posœnnomnèse") + " travaille la mémoire opérative, la rémanence du verbe et le point d’accord où la mémoire rejoint la régulation au sein de " + canon("Katûvýs") + ".",
        en: canon("Posœnnomnèse") + " works operative memory, the remanence of the verb, and the point of accord where memory rejoins regulation within " + canon("Katûvýs") + ".",
        es: canon("Posœnnomnèse") + " trabaja la memoria operativa, la remanencia del verbo y el punto de acuerdo donde la memoria se une a la regulación dentro de " + canon("Katûvýs") + "."
      }
    },
    {
      title:"Humanus",
      href: URLS.humanus,
      img: URLS.humanus_img,
      label: { fr:"Annexe incarnée", en:"Embodied annex", es:"Anexo encarnado" },
      desc: {
        fr: canon("Humanus") + " inscrit l’être humain comme particule vibratoire et unité de conscience en syntonie avec " + canon("Katûvýs") + ", où mémoire, perception et souffle deviennent passage habitable.",
        en: canon("Humanus") + " inscribes the human being as a vibratory particle and unit of consciousness in syntony with " + canon("Katûvýs") + ", where memory, perception and breath become a habitable passage.",
        es: canon("Humanus") + " inscribe al ser humano como partícula vibratoria y unidad de conciencia en sintonía con " + canon("Katûvýs") + ", donde memoria, percepción y aliento se vuelven un paso habitable."
      }
    }
  ];

  var TOTEM = {
    title:"Êkhö",
    href: URLS.ekho,
    img: URLS.ekho_img,
    label: { fr:"Totem transversal", en:"Transversal totem", es:"Tótem transversal" },
    desc: {
      fr: canon("Êkhö") + " agit comme totem de résonance autonome, vivante, écosophique, traversante et ajustante. Il accompagne des unités internes de " + canon("Katûvýs") + " et des points-clefs d’émanation, en modulant les intensités du milieu plutôt qu’en les figeant.",
      en: canon("Êkhö") + " acts as a totem of autonomous, living, ecosophic, traversing and adjusting resonance. It accompanies internal units of " + canon("Katûvýs") + " and key points of emanation by modulating the milieu’s intensities rather than freezing them.",
      es: canon("Êkhö") + " actúa como tótem de resonancia autónoma, viva, ecosófica, atravesante y ajustante. Acompaña unidades internas de " + canon("Katûvýs") + " y puntos clave de emanación modulando las intensidades del medio en vez de fijarlas."
    }
  };

  function renderAxis(root, lang){
    var L = chooseFallback(lang);
    var eMain = resolveMainEntry(root);

    var titleFR = (eMain ? pickTerm(eMain, "fr") : "") || FALLBACK.fr.title;
    setSlotText(root, "title", titleFR);
    setSlotImg(root, "title_img", URLS.title_img, titleFR);

    var kicker = "";
    if (eMain){
      kicker =
        clampStr(pickAny(eMain, "kicker_" + lang, "")) ||
        clampStr(pickAny(eMain, "kicker_fr", "")) ||
        clampStr(pickAny(eMain, "kicker", ""));
    }
    setSlotHTML(root, "kicker", kicker || L.kicker);

    setSlotText(root, "h_def", L.h_def);
    setSlotHTML(root, "def_short", "<div>" + protectKeywordsHTML(escapeHTML(L.def_short)) + "</div>");
    setSlotHTML(root, "def_long", htmlParagraphize(L.def_long));

    setSlotText(root, "h_bands", L.h_bands);
    renderCardGrid(root, "bands_cards", BANDS, lang);

    setSlotText(root, "h_annexes", L.h_annexes);
    renderCardGrid(root, "annexes_cards", ANNEXES, lang);

    setSlotText(root, "h_totem", L.h_totem);
    setSlotHTML(root, "totem_card", buildCard(TOTEM, lang));

    setSlotText(root, "h_features", L.h_features);
    setSlotText(root, "hint_fold", L.hint_fold);
    renderListInto(root, "features", L.features || []);

    setSlotText(root, "h_questions", L.h_questions);
    setSlotText(root, "hint_fold2", L.hint_fold2);
    renderListInto(root, "questions", L.questions || []);
    setSlotHTML(
      root,
      "example_box",
      '<div><strong>' + protectKeywordsHTML(escapeHTML(L.example_title || "Ex.")) + '</strong> ' + protectKeywordsHTML(escapeHTML(L.example || "")) + '</div>'
    );

    setSlotText(root, "h_family", L.h_family);
    setSlotText(root, "hint_fold3", L.hint_fold3);
    setSlotHTML(root, "family_1", L.family_1 || "");
    setSlotHTML(root, "family_2", L.family_2 || "");

    setSlotText(root, "h_wordbuild", L.h_wordbuild);
    renderWordBlocks(root, "wordbuild_blocks", L.word_blocks || []);
    renderListInto(root, "wordbuild_notes", L.word_notes || []);

    setSlotText(root, "h_usage", L.h_usage || "");
    renderListInto(root, "usage_points", L.usage_points || []);

    setSlotText(root, "h_relations", L.h_relations || "");
    setSlotHTML(root, "relations_html", L.relations_html || "");

    setSlotText(root, "h_composition", L.h_composition || "");
    setSlotHTML(root, "composition_intro", L.composition_intro || "");
    renderWordBlocks(root, "composition_blocks", L.composition_blocks || []);
    renderListInto(root, "composition_notes", L.composition_notes || []);

    setCtaTranslate(root, lang);
  }

  function setPressed(root, lang){
    var btns = root.querySelectorAll(".po-langbtn[data-po-lang]");
    for (var i=0;i<btns.length;i++){
      var b = btns[i];
      var l = normLang(b.getAttribute("data-po-lang") || "");
      var on = (l === lang);
      b.setAttribute("aria-pressed", on ? "true" : "false");
      if (b.classList && b.classList.toggle) b.classList.toggle("is-active", !!on);
    }
    var bar = root.querySelector("[data-po-langbar]");
    if (bar){
      var labels = { fr:"Choisir la langue", en:"Choose language", es:"Elegir idioma" };
      bar.setAttribute("aria-label", labels[lang] || labels.fr);
    }
  }

  function bindLangBars(){
    var roots = getTargetBlocks();
    for (var i=0;i<roots.length;i++){
      var root = roots[i];
      var bar = root.querySelector("[data-po-langbar]");
      if (!bar || bar.__poLangBound) continue;
      bar.addEventListener("click", function(ev){
        var btn = ev.target && ev.target.closest ? ev.target.closest(".po-langbtn[data-po-lang]") : null;
        if (!btn) return;
        ev.preventDefault();
        var lang = normLang(btn.getAttribute("data-po-lang") || "fr");
        var api = window.PoKatupirsia5KatuvysTextsFR_EN_ES_20260303;
        if (api && typeof api.setLang === "function") api.setLang(lang);
        else if (api && typeof api.init === "function") api.init();
      });
      bar.__poLangBound = true;
    }
  }

  function lexiconLooksReady(){
    try{
      if (window.PO_LEXICON_MAP) return true;
      if (Array.isArray(window.PO_LEXICON) && window.PO_LEXICON.length) return true;
    }catch(e){}
    return false;
  }

  function applyLangEverywhere(lang){
    var l = normLang(lang || getLang());
    storeLang(l);
    stopAudio();

    var roots = getTargetBlocks();
    for (var i=0;i<roots.length;i++){
      setPressed(roots[i], l);
      renderAxis(roots[i], l);
    }

    initAudioEverywhere(l);
    notifyLocaleChanged();
  }

  function init(){
    bindLangBars();
    applyLangEverywhere(getLang());

    if (!lexiconLooksReady()){
      var tries = 0;
      var maxTries = 80;
      var timer = setInterval(function(){
        tries++;
        if (lexiconLooksReady() || tries >= maxTries){
          clearInterval(timer);
          __PO_PROTECT_CACHE__.key = "";
          __PO_PROTECT_CACHE__.re = null;
          applyLangEverywhere(getLang());
        }
      }, 100);
    }
  }

  window.addEventListener("po:lexicon-ready", function(){
    __PO_PROTECT_CACHE__.key = "";
    __PO_PROTECT_CACHE__.re = null;
    try{ applyLangEverywhere(getLang()); }catch(e){}
  });

  window.PoKatupirsia5KatuvysTextsFR_EN_ES_20260303 = {
    getLang: getLang,
    setLang: applyLangEverywhere,
    init: init,
    normLang: normLang,
    stopAudio: stopAudio
  };

  try{
    if (!window.GoodyTwinLang){
      window.GoodyTwinLang = { init:init, getLang:getLang, setLang:applyLangEverywhere };
    }else{
      if (typeof window.GoodyTwinLang.getLang !== "function") window.GoodyTwinLang.getLang = getLang;
      if (typeof window.GoodyTwinLang.setLang !== "function") window.GoodyTwinLang.setLang = applyLangEverywhere;
      if (typeof window.GoodyTwinLang.init !== "function") window.GoodyTwinLang.init = init;
    }
  }catch(e){}

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

})();
